(function() {
  function getActiveIndex(track) {
    return Math.round(track.scrollLeft / track.clientWidth);
  }

  function updateState(slider) {
    const track = slider.querySelector('[data-slider-track]');
    const slides = slider.querySelectorAll('.product-card__slide');
    const idx = getActiveIndex(track);

    slider.querySelectorAll('.product-card__slider-dot').forEach(d => {
      d.classList.toggle('is-active', parseInt(d.dataset.sliderDot, 10) === idx);
    });

    const prev = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    if (prev) prev.disabled = idx <= 0;
    if (next) next.disabled = idx >= slides.length - 1;
  }

  function goTo(slider, index) {
    const track = slider.querySelector('[data-slider-track]');
    track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
  }

  function init() {
    document.querySelectorAll('[data-card-slider]').forEach(slider => {
      if (slider.dataset.init) return;
      slider.dataset.init = '1';

      const track = slider.querySelector('[data-slider-track]');
      let ticking = false;
      track.addEventListener('scroll', () => {
        if (!ticking) {
          requestAnimationFrame(() => { updateState(slider); ticking = false; });
          ticking = true;
        }
      }, { passive: true });

      updateState(slider);
    });
  }

  // Arrow + dot clicks
  document.addEventListener('click', (e) => {
    const prev = e.target.closest('[data-slider-prev]');
    const next = e.target.closest('[data-slider-next]');
    const dot  = e.target.closest('[data-slider-dot]');
    if (!prev && !next && !dot) return;

    e.preventDefault();
    e.stopPropagation();

    const slider = (prev || next || dot).closest('[data-card-slider]');
    const track  = slider.querySelector('[data-slider-track]');
    const slides = slider.querySelectorAll('.product-card__slide');
    const idx    = getActiveIndex(track);

    if (prev)  goTo(slider, Math.max(0, idx - 1));
    if (next)  goTo(slider, Math.min(slides.length - 1, idx + 1));
    if (dot)   goTo(slider, parseInt(dot.dataset.sliderDot, 10));
  });

  // Variant change → scroll the slider to that variant's image
  document.addEventListener('change', (e) => {
    if (!e.target.matches('.variant-option-radio-input')) return;
    const card = e.target.closest('product-card');
    if (!card) return;
    const slider = card.querySelector('[data-card-slider]');
    if (!slider) return;

    setTimeout(() => {
      let variants = [];
      try {
        variants = JSON.parse(card.querySelector('[data-product-variants-json]')?.textContent || '[]');
      } catch (err) { return; }

      const checkedValues = [...card.querySelectorAll('.variant-option-radio-input:checked')].map(r => r.value);
      const match = variants.find(v => checkedValues.every(val => v.options.includes(val)));
      if (!match) return;

      const slide = [...card.querySelectorAll('.product-card__slide')].find(s => {
        const ids = (s.dataset.productImages || '').split(',').filter(Boolean);
        return ids.includes(String(match.id));
      });
      if (slide) goTo(slider, parseInt(slide.dataset.slideIndex, 10));
    }, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();